/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getF64Decoder,
  getF64Encoder,
  getStructDecoder,
  getStructEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Latitude range for geographic constraints */
export type LatitudeRange = {
  /** Minimum latitude */
  min: number;
  /** Maximum latitude */
  max: number;
};

export type LatitudeRangeArgs = LatitudeRange;

export function getLatitudeRangeEncoder(): FixedSizeEncoder<LatitudeRangeArgs> {
  return getStructEncoder([
    ["min", getF64Encoder()],
    ["max", getF64Encoder()],
  ]);
}

export function getLatitudeRangeDecoder(): FixedSizeDecoder<LatitudeRange> {
  return getStructDecoder([
    ["min", getF64Decoder()],
    ["max", getF64Decoder()],
  ]);
}

export function getLatitudeRangeCodec(): FixedSizeCodec<
  LatitudeRangeArgs,
  LatitudeRange
> {
  return combineCodec(getLatitudeRangeEncoder(), getLatitudeRangeDecoder());
}
